// Filename: Navbar.js
import React, { useState } from "react";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useMatch, useResolvedPath } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "./auth/authSlice";
const Nav = styled.nav`
  background: #ff6699;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  position: relative;
  z-index: 1;
`;


const NavList = styled.ul`
  display: flex;
  list-style: none;

  @media (max-width: 768px) {
    display: ${(props) => (props.open ? "flex" : "none")};
    flex-direction: column;
    width: 100%;
    position: absolute;
    top: 60px;
    left: 0;
    background: #f2f2f2;
    padding: 20px 0;
    z-index: 2;
  }
`;
const NavItem = styled.li`
  margin: 0 10px;
  padding: 10px 15px;
  border-radius: 5px;
  transition: background-color 0.3s, border-radius 0.3s;

  &.active,
  &:hover {
    background-color: #fff;
    border-radius: 15px;
    color: red !important;
    @media (max-width: 768px) {
      background-color: #ffffff;
      color: #ff3c8a !important;
    }
  }
  abc {
    background-color: #ff3c8a;
  }

  @media (max-width: 768px) {
    margin: 10px 0;
  }
`;

const HamburgerIcon = styled.div`
  display: none;
  z-index: 3;

  @media (max-width: 768px) {
    display: block;
  }
`;

export default function Navbar({ authUser }) {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const dispatch = useDispatch();
  const handleToggle = () => {
    setHamburgerOpen(!hamburgerOpen);
  };

  return (
    <Nav>
      <Link to="/">
        <img src={require("../images/reciteontvlogo.png")} alt="Recite On TV Logo" style={{width:315,height:45,maxWidth: "100%"}}/>
      </Link>
      <HamburgerIcon onClick={handleToggle}>
        {hamburgerOpen ? <FaTimes /> : <FaBars />}
      </HamburgerIcon>
      <NavList open={hamburgerOpen}>
        <CustomLink to="/" onClick={handleToggle}>
          Home
        </CustomLink>
        <CustomLink to="/Watch" onClick={handleToggle}>
          Watch
        </CustomLink>
        <CustomLink to="/Rules" onClick={handleToggle}>
          Rules
        </CustomLink>
        {/* <CustomLink to="/Upload" onClick={handleToggle}>
          Upload
        </CustomLink> */}
        <CustomLink
          to="https://donateislam.com/donate/recite/"
          onClick={handleToggle}
        >
          Donate
        </CustomLink>
        {/* {!authUser?.token ? (
          <>
            <CustomLink to="/Login" onClick={handleToggle}>
              Login
            </CustomLink>
          </>
        ) : (
          <>
            <CustomLink
              to="/Login"
              onClick={() => {
                handleToggle();
                dispatch(logout());
              }}
            >
              Logout
            </CustomLink>
          </>
        )} */}
      </NavList>
    </Nav>
  );
}
const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  @media (max-width: 768px) {
    color: #333;
  }
`;
function CustomLink({ to, children, onClick, ...props }) {
  const resolvedPath = useResolvedPath(to);
  const isActive = useMatch({ path: resolvedPath.pathname, end: true });

  const handleClick = (e) => {
    if (typeof onClick === "function") {
      onClick(e);
    }
  };

  return (
    <StyledLink to={to} {...props}>
      <NavItem className={isActive ? "active" : ""} onClick={handleClick}>
        {children}
      </NavItem>
    </StyledLink>
  );
}
